import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "set-new-password-form" }

import { PropType, computed, ref } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import i18n from '@/i18n'
import PasswordReset from '@/utils/password-reset'

interface FormError {
  isOk: boolean
  message?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordResetForm',
  props: {
  token: {
    type: String as PropType<string>,
    required: true,
  },
},
  setup(__props) {

const props = __props

/* local state */

const formData = ref<{ password: string; confirmation: string }>({
  password: '',
  confirmation: '',
})
const isError = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const isSuccess = ref<boolean>(false)

/* computed */

const formError = computed<FormError>((): FormError => {
  const password = formData.value.password as string
  const confirmation = formData.value.confirmation as string

  if (password.length === 0 && confirmation.length === 0) {
    return { isOk: false }
  }

  if (password.length < 8) {
    return {
      isOk: false,
      message: i18n.global.t('password-reset.password-too-short-error'),
    }
  }

  if (password.length > 72) {
    return {
      isOk: false,
      message: i18n.global.t('password-reset.password-too-long-error'),
    }
  }

  if (confirmation !== password) {
    return {
      isOk: false,
      message: i18n.global.t('password-reset.password-mismatch'),
    }
  }

  return { isOk: true }
})

/* actions */

const submit = async (): Promise<void> => {
  isLoading.value = true

  const isPasswordUpdated = await PasswordReset.updatePassword(
    props.token,
    formData.value.password,
  )

  isSuccess.value = isPasswordUpdated
  isError.value = !isPasswordUpdated
  formData.value = { password: '', confirmation: '' }
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSuccess.value & !isError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(NotificationBanner, {
            message: _ctx.$t('password-reset.password-update-succeeded-message'),
            "is-success": ""
          }, null, 8, ["message"]),
          _createVNode(RouterLinkButton, { to: { path: '/login' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.login')), 1)
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isError.value)
            ? (_openBlock(), _createBlock(NotificationBanner, {
                key: 0,
                message: _ctx.$t('password-reset.password-update-failed-message'),
                "is-danger": ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            autocomplete: "off",
            spellcheck: "false",
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            (!formError.value.isOk && formError.value.message)
              ? (_openBlock(), _createBlock(NotificationBanner, {
                  key: 0,
                  message: formError.value.message,
                  "is-danger": ""
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            _createVNode(FormTextInput, {
              modelValue: formData.value.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.password) = $event)),
              name: "password",
              type: "password",
              label: _ctx.$t('field-labels.new-password'),
              "is-disabled": isLoading.value,
              "is-required": ""
            }, null, 8, ["modelValue", "label", "is-disabled"]),
            _createVNode(FormTextInput, {
              modelValue: formData.value.confirmation,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.confirmation) = $event)),
              name: "confirmation",
              type: "password",
              label: _ctx.$t('field-labels.password-confirmation'),
              "is-disabled": isLoading.value,
              "is-required": ""
            }, null, 8, ["modelValue", "label", "is-disabled"]),
            _createVNode(FormButton, {
              "is-busy": isLoading.value,
              "is-disabled": !formError.value.isOk
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('password-reset.update-password')), 1)
              ]),
              _: 1
            }, 8, ["is-busy", "is-disabled"])
          ], 32)
        ], 64))
  ]))
}
}

})